<app-tree-table
  (focusYearChange)="focusYearChange($event)"
  [actionColumnWidth]="530"
  [columns]="columns"
  [firstColumnFrozen]="true"
  [focusYear]="focusYear"
  [hasFocusYear]="true"
  [loading]="loading"
  [value]="tree"
  sortField="name">
  <ng-template
    (onClick)="create()"
    appToolbarButton
    icon="fal fa-plus"
    labelKey="ANWENDERBETRIEBE.CREATE_NEW"></ng-template>
  <ng-template
    (onClick)="delete($event.row)"
    appActionButton
    displayIfNot="node.data.deleting"
    icon="fal fa-trash"
    labelKey="ACTIONS.DELETE"
    type="danger"></ng-template>
  <ng-template
    (onClick)="deleteDataOnly($event.row)"
    appActionButton
    displayIfNot="node.data.deleting"
    icon="fal fa-undo"
    labelKey="ANWENDERBETRIEBE.DELETE_DATA_ONLY"
    type="warning"></ng-template>
  <ng-template
    (onClick)="downloadLicenseProof($event.row)"
    appActionButton
    displayIf="node.data.isAnwenderbetrieb"
    displayIfNot="node.data.deleting"
    icon="fal fa-download"
    labelKey="ANWENDERBETRIEBE.DOWNLOAD_LICENSE_PROOF"></ng-template>
  <ng-template
    [disabled]="true"
    appActionButton
    displayIf="node.data.deleting"
    icon="fal fa-hourglass-half"
    labelKey="ANWENDERBETRIEBE.DELETION_IN_PROGRESS"
    type="secondary"></ng-template>
</app-tree-table>
